import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { HeatingSystem } from '../../types/heating-system';
import { LeadStatus } from '../../types/lead-status';
import { LeadDetails } from '../../types/leads';

export interface Fuel {
    type: string;
    id: string;
}

export interface TrueFalse {
    type: boolean;
    name: string;
}

/**
 * @title Table with sticky columns
 */
@Component({
    selector: 'newleads-add',
    styleUrls: ['newleads-add.component.css'],
    templateUrl: 'newleads-add.component.html',
    providers: [HubService],
})
export class NewLeadsAddComponent implements OnInit {
    @ViewChild('table') ITableRef: ElementRef;
    @Output() open_close = new EventEmitter<boolean>();

    isDisabled: boolean;
    isUploading: boolean;
    failFlag: boolean;

    errorMessage: string;
    heatingSystemList = <HeatingSystem[]>[];
    leadStatusList = <LeadStatus[]>[];
    newLead = {} as LeadDetails
    loading_data: boolean;

    fuels: Fuel[] = [
        { type: 'Oil', id: 'oil' },
        { type: 'Gas', id: 'gas' },
        { type: 'Other', id: 'other' }
    ];

    truefalse: TrueFalse[] = [
        { type: true, name: "true" },
        { type: false, name: "false" }
    ];

    constructor(
        private hubService: HubService,
    ) { }

    ngOnInit(): void {
        if (!AppComponent.IsLoggedIn()) { return; }

        this.loading_data = true;
        this.isDisabled = false;
        this.isUploading = false
        this.failFlag = false;


        this.hubService.getLookupTable('lead_status').subscribe(
            lookup_values => this.leadStatusList = <LeadStatus[]>lookup_values,
            error => this.errorMessage = <any>error,
        );
        this.hubService.getLookupTable('heating_system').subscribe(
            lookup_values => this.heatingSystemList = <HeatingSystem[]>lookup_values,
            error => this.errorMessage = <any>error,
        );
    }

    ngAfterViewInit() { }

    addNew() {
        console.log(this.newLead);
        this.newLead.source = "manual";
        this.newLead.approved = true;
        this.newLead.dead_lead = false;
        this.hubService.addLead(this.newLead)
            .subscribe(
                data => {
                    console.log(data.status),
                    this.newLead = new LeadDetails;
                    this.sendFlag();
                },
                error => this.errorMessage = <any>error,
            );
    }

    cancelNew() {
        this.newLead = new LeadDetails;
        this.sendFlag();
    }

    sendFlag() {
        this.open_close.emit(false);
    }
}
